<template>
  <div id="principal">
    <ItemLista height="83" :ativo="true">
      <div class="col-7 d-flex align-center pa-0 pr-3">
        <div class="cursor-pointer" @click="selecionar(item)">
          <v-icon v-if="ESTA_SELECIONADO" color="#142454" v-text="'mdi-checkbox-marked'" />
          <v-icon v-else color="#142454" v-text="'mdi-checkbox-blank-outline'" />
        </div>

        <div class="cursor-pointer px-1" @click="expandir">
          <v-icon v-if="item.expandido" v-text="'mdi-chevron-down'" />
          <v-icon v-else v-text="'mdi-chevron-right'" />
        </div>

        <p
          class="coluna-principal text-truncate"
          v-text="item.nome_fornecedor"
          :title="item.nome_fornecedor" />
      </div>

      <div class="col-5 pa-0">
        <p class="titulo-informacao" v-text="'Cotação Atual'" />

        <p class="informacao">
          <span class="descricao">Categorias que atende: </span>
          <span class="valor" v-text="item.cotacao_atual.categorias_que_atende" />
        </p>

        <p class="informacao">
          <span class="descricao">Matéria prima que atende: </span>
          <span class="valor" v-text="item.cotacao_atual.materia_prima_que_atende" />
        </p>

        <p class="informacao">
          <span class="descricao">Quantidade a ser cotada: </span>
          <span class="valor" v-text="item.cotacao_atual.qtd_peso_cotada" />
        </p>
      </div>
    </ItemLista>

    <v-expand-transition id="departamentos-do-fornecedor">
      <CategoriasAtendidas
        :ativo="item.expandido"
        :fornecedor="item"
        :fornecedor_esta_selecionado="ESTA_SELECIONADO"
        @selecionar="selecionar"
      />
    </v-expand-transition>
  </div>
</template>

<script>
import ItemLista from "./ItemLista";
import CategoriasAtendidas from "./CategoriasAtendidas";

export default {
  name: "FornecedorPorCotar",
  components: {
    CategoriasAtendidas,
    ItemLista,
  },
  props: {
    item: Object,
    fornecedores_seleionados: Array,
  },
  computed: {
    ESTA_SELECIONADO() {
      return this.fornecedores_seleionados.some(item => item.id_fornecedor === this.item.id_fornecedor);
    }
  },
  methods: {
    selecionar(fornecedor) {
      this.$emit('selecionar', fornecedor);
    },
    expandir() {
      this.item.expandido = !this.item.expandido;
    }
  }
}
</script>

<style scoped>
</style>
